import { ClientContextService } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { DateTime } from 'luxon';

export class TransportPrintIdentityCardController extends AbstractStepController {

    private terminalConnectorUrl: string = null;

    configurationService: ConfigurationService;
    clientContextService: ClientContextService;
    translationService: TranslationService;
    httpService: HttpService;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(ConfigurationService);
        this.httpService = WizardServiceLocator.injector.get(HttpService);
        this.clientContextService = WizardServiceLocator.injector.get(ClientContextService);
        this.translationService = WizardServiceLocator.injector.get(TranslationService);
        const terminalHardwareUrl = this.configurationService.getDeviceParam('terminalhardwareconnector.url');
        if (terminalHardwareUrl != null && terminalHardwareUrl.value.trim().length > 0) {
          this.terminalConnectorUrl = this.configurationService.getDeviceParam('terminalhardwareconnector.url').value;
        }
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
      if (this.terminalConnectorUrl == null) {
        console.log('No terminalConnector URL configured. Skip printing');
        this.wizardComponent.next();
      } else {
        this.httpService.post(this.terminalConnectorUrl + '/io/printer/print', this.buildPrintJobData()).subscribe(result => {
          console.log('print finished');
          this.wizardComponent.next();
        },
        error => {
          console.log('error received');
          this.wizardComponent.next();
        });
      }
    }

    public handleFlow(): FlowStepHandleResult {
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.PROCESSING;
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private buildPrintJobData(): any {
      const context = this.clientContextService.getCurrentContext();
      const driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
      const carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
      const supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
      const orderReference = this.dashboardContext.getContextValue(TerminalContextConstants.orderReference);
      const numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
      const registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
      const registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);

      return {
        yardKey: context.unit.key,
        type: 'TRANSPORT_IDENTITY_CARD',
        labels: {
          'label.driver': this.translationService.translate('tmc-yard.entity.transport.driver'),
          'label.carrier': this.translationService.translate('tmc-yard.entity.transport.carrier'),
          'label.supplier': this.translationService.translate('tmc-yard.entity.transport.supplier'),
          'label.numberPlate': this.translationService.translate('tmc-yard.entity.transport.numberplate'),
          'label.orderReference': this.translationService.translate('tmc-yard.entity.transport.reference'),
          'label.registrationFinished': this.translationService.translate('tmc-yard.entity.transport.registrationFinished')

        },
        values: {
          driver: driver,
          carrier : carrier,
          supplier: supplier,
          orderReference: orderReference,
          numberPlate: numberPlate,
          registrationFinished: DateTime.fromJSDate(new Date(registrationFinished)).toFormat("dd.MM.yyyy HH:mm"),
          qrCode: registrationCode != null ? 'tmc-yard://transport/' + registrationCode : null
        }
      };
    }
}
